import React from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";

const Home: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-purple-600 flex flex-col">
      {/* Header */}
      <header className="container mx-auto px-4 py-6 flex justify-between items-center">
        <div className="flex items-center space-x-2 md:space-x-3">
          {/* Logo Icon */}
          <div className="relative">
            <svg 
              className="w-12 h-12 md:w-16 md:h-16 text-white" 
              viewBox="0 0 32 32" 
              fill="currentColor"
            >
              {/* Main star shape */}
              <path d="M16 2L19.09 11.26L28 12L19.09 12.74L16 22L12.91 12.74L4 12L12.91 11.26L16 2Z" />
              {/* Inner sparkle */}
              <path d="M16 8L17.5 12.5L22 14L17.5 15.5L16 20L14.5 15.5L10 14L14.5 12.5L16 8Z" fill="rgba(255,255,255,0.3)" />
            </svg>
          </div>
          {/* Brand Name */}
          <div className="text-white text-xl md:text-3xl font-bold">Startup Worth</div>
        </div>
        <div className="flex gap-3">
          <button
            onClick={() => navigate("/form")}
            className="bg-white text-purple-600 px-4 md:px-6 py-2 md:py-3 rounded-full font-semibold hover:bg-opacity-90 transition-all duration-300 shadow-md hover:shadow-lg text-sm md:text-base"
          >
            Get Valuation
          </button>
          <button
            onClick={() => navigate("/booking")}
            className="bg-white/10 text-white px-4 md:px-6 py-2 md:py-3 rounded-full font-semibold hover:bg-white/20 transition-all duration-300 shadow-md hover:shadow-lg text-sm md:text-base border border-white/30"
          >
            Book Consultation
          </button>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 container mx-auto px-4 flex flex-col items-center justify-center text-center">
        {/* Main Headline */}
        <h1 className="text-white text-4xl md:text-6xl lg:text-7xl font-bold max-w-5xl leading-tight mb-12 tracking-tight px-4">
          Get a real-time valuation for your startup. No guesswork.
        </h1>

        {/* Canva Animation Section */}
        <div className="w-full max-w-4xl mx-auto mb-12">
          <div className="relative rounded-3xl shadow-2xl overflow-hidden" style={{ aspectRatio: '16/9' }}>
            <div className="absolute inset-0 bg-gradient-to-t from-purple-600/50 to-transparent z-10 pointer-events-none"></div>
            <iframe 
              loading="lazy" 
              src="https://www.canva.com/design/DAGqzmXl_v8/Zf_IH9VxtW5RLgZPCKQQhQ/view?embed" 
              className="absolute w-full h-full top-0 left-0 border-none p-0 m-0"
              allowFullScreen={true}
              title="Startup Growth Visualization"
            />
          </div>
        </div>
        
        {/* Button Section */}
        <div className="mt-8 flex flex-col sm:flex-row gap-4">
          <button
            onClick={() => navigate("/form")}
            className="bg-gradient-to-r from-purple-500 to-purple-700 text-white px-10 py-4 rounded-full font-semibold hover:from-purple-600 hover:to-purple-800 transition-all duration-300 text-lg flex items-center justify-center shadow-lg hover:shadow-xl transform hover:scale-105"
          >
            Get Valuation
            <svg
              className="ml-3 w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
          <button
            onClick={() => navigate("/booking")}
            className="bg-white/10 text-white px-10 py-4 rounded-full font-semibold hover:bg-white/20 transition-all duration-300 text-lg flex items-center justify-center shadow-lg hover:shadow-xl transform hover:scale-105 border border-white/30"
          >
            Book Expert Consultation
            <svg
              className="ml-3 w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
          </button>
        </div>
      </main>
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Home; 